export interface GLContext {
  gl: WebGL2RenderingContext;
  canvas: HTMLCanvasElement;
}

export const createGLContext = (canvas: HTMLCanvasElement): GLContext => {
  const gl = canvas.getContext('webgl2', {
    alpha: false,
    antialias: false,
    depth: true,
    stencil: false,
    powerPreference: 'high-performance',
    preserveDrawingBuffer: false,
    premultipliedAlpha: true,
    failIfMajorPerformanceCaveat: false,
  });
  if (gl === null) {
    throw new Error('webgl2 is not supported on this device');
  }

  gl.enable(gl.DEPTH_TEST);
  gl.depthFunc(gl.LEQUAL);
  gl.enable(gl.CULL_FACE);
  gl.cullFace(gl.BACK);
  gl.frontFace(gl.CCW);
  gl.clearColor(0.04, 0.05, 0.07, 1);
  gl.clearDepth(1);

  return { gl, canvas };
};
